import React from "react";
import { entries, groupBy } from "lodash";
import styled, { css } from "styled-components";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";

import { ChartShape, ChartLabel } from "@components/atoms";
import { CHART_COLOR } from "@constants/chartColor";
import { device } from "@scss/constants/mediaQuery";

import type { Statistic } from "@interfaces/stats";
import type { Status } from "@enums/statistic";
import type { FC } from "react";

type Chart = { status: string; value: number; color: string; name?: number };

type ChartsProps = {
  statistic: Statistic[];
};

const Chart: FC<ChartsProps> = ({ statistic }) => {
  const stats = groupBy(statistic, "statusName");
  const activeIndex: number[] = [];

  let total = 0;

  const chartData = entries(stats).reduce<Chart[]>((acc, curr, ind) => {
    const stat: Chart = {
      value: curr[1].length,
      status: curr[0],
      color: CHART_COLOR[curr[0] as Status],
    };

    activeIndex.push(ind);
    total += stat.value;

    acc.push(stat);

    return acc;
  }, []);

  if (chartData.length) {
    chartData[0].name = total;
  }

  return (
    <Wrapper>
      <StyledPieChart>
        <Pie
          cx="50%"
          cy="50%"
          data={chartData}
          fill="#8884d8"
          outerRadius={80}
          innerRadius={55}
          labelLine={false}
          activeIndex={activeIndex}
          label={ChartLabel}
          activeShape={ChartShape}
          dataKey="value"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </StyledPieChart>
    </Wrapper>
  );
};

const StyledPieChart = styled(PieChart)`
  width: 100%;
  height: 60% !important;

  ${device.tablet(css`
    height: 70% !important;
  `)}

  ${device.laptopS(css`
    height: 85% !important;
  `)}

  ${device.laptopL(css`
    height: 100% !important;
  `)}
`;

const Wrapper = styled(ResponsiveContainer)`
  width: 100%;
  height: 42% !important;
  max-height: 400px;

  display: flex;
  justify-content: center;
  align-items: center;

  ${device.laptopS(css`
    height: 100% !important;
    width: 40% !important;
  `)}

  ${device.laptopL(css`
    width: 50% !important;
  `)}
`;

export default Chart;
